import React, { Component } from 'react';

export default class Toast extends Component {
	constructor(props) {
		super(props);
		this.state = {

		};
	};

	handleOnClick = (event) => {

	}

	render() {
		let style = {
			color: 'rgba(255, 255, 255, 0.8)',
			backgroundColor: 'black',
			opacity: 0.8,
			width: this.props.width * 0.9,
			left: this.props.width * 0.05,
			height: this.props.height != null ? this.props.height : 50,
			position: 'absolute',
			top: this.props.top,
			zIndex: 1,
			borderRadius: 10,
		};

		let message_style = {
			paddingLeft: 10,
			paddingRight: 10,
		}

		style = Object.assign(style, this.props.style);

		return (
			<div style={style} className={this.props.is_show ? 'slideInDown' : 'slideOutUp'}>
				<p style={message_style}>{this.props.message}</p>
			</div>
		);
	}
}